import { ApplicationJson } from '@/apis/base/httpclient';
import PlatformIntegrationApi from './_platformIntegrationApi';

class PlatformIntegrationAccountApi extends PlatformIntegrationApi {
  /**
   * Lấy danh sách đơn vị của user (yêu cầu pre-auth token).
   * @param {string} preAuthToken
   */
  async getTenants(preAuthToken) {
    const request = {
      url: [this.getAPIUrl(), 'tenants'].join('/'),
      data: {},
      headers: { Authorization: `Bearer ${preAuthToken}` },
      withCredentials: false,
    };
    return this.getAsync(request, true, false, ApplicationJson, false);
  }

  /**
   * Chọn tenant và tạo session.
   * @param {object} tenant - tenant item từ danh sách (TenantItemDto)
   * @param {string} preAuthToken
   * @param {string} [callback] - URL callback sau login (tùy chọn, BE sẽ validate cùng host)
   */
  async switchTenant(tenant, preAuthToken, callback = '') {
    const request = {
      url: [this.getAPIUrl(), 'switch-tenant'].join('/'),
      data: {
        tenant_id: tenant.tenant_id,
        tenant_name: tenant.tenant_name,
        budget_code: tenant.budget_code,
        sub_tenant_id: tenant.sub_tenant_id || '',
        sub_tenant_name: tenant.sub_tenant_name || '',
        sub_tenant_budget_code: tenant.sub_tenant_budget_code || '',
        platform_version: tenant.platform_version || '',
        app_code: tenant.app_code || '',
        context: 'login',
        callback: callback,
      },
      headers: { Authorization: `Bearer ${preAuthToken}` },
      withCredentials: false,
    };
    return this.postAsync(request, true, false, ApplicationJson, false);
  }
}

export default new PlatformIntegrationAccountApi();
